import { createSelector } from 'react-sweet-state';

import {
	FileStatus,
	type ModifiedFieldValues,
} from '../../../../common/types/form/form-fields/field-values';
import { asModifiedFilesValue } from '../../../../common/types/form/form-fields/field-values/utils';
import type { FormRendererState } from '../../types';

/**
 * Returns true if any file in the form is currently uploading
 */
export const fileUploadProgressSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	boolean
> = createSelector(
	(state: FormRendererState) => state.modifiedValues,
	(modifiedValues: ModifiedFieldValues) =>
		Object.values(modifiedValues).some(
			(fieldValue) => asModifiedFilesValue(fieldValue)?.fileStatus === FileStatus.UPLOADING,
		),
);
